package or.garden.manager.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun CardSkeleton() {
    Div({
        classes("bg-white", "rounded-3xl", "p-8", "shadow-sm", "border", "border-gray-100", "animate-pulse")
    }) {
        // Icon Circle Placeholder
        Div({
            classes("w-14", "h-14", "bg-gray-200", "rounded-2xl", "mb-6", "shimmer-effect")
        })
        
        // Title Placeholder
        Div({
            classes("h-8", "bg-gray-200", "rounded-lg", "w-3/4", "mb-4", "shimmer-effect")
        })
        
        // Subtitle Placeholder
        Div({
            classes("h-4", "bg-gray-200", "rounded-lg", "w-1/2", "mb-8", "shimmer-effect")
        })
        
        // Footer Placeholder
        Div({
            classes("flex", "justify-between", "items-center", "mt-10", "pt-6", "border-t", "border-gray-50")
        }) {
            Div({ classes("h-4", "bg-gray-200", "rounded-lg", "w-20", "shimmer-effect") })
            Div({ classes("h-4", "bg-gray-200", "rounded-lg", "w-24", "shimmer-effect") })
        }
    }
}
